import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=2672ae8d&scoped=true&"
import script from "./HomePage.vue?vue&type=script&lang=ts&"
export * from "./HomePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2672ae8d",
  null
  
)

export default component.exports